import { groupBy } from 'es-toolkit';

import { ProductionComponentInstance, ProductionComponentInstanceStatus } from '@paragon/contract-library';

export interface StatusPercentage {
  status: ProductionComponentInstanceStatus;
  percentage: number;
}

const orderedStatuses: readonly ProductionComponentInstanceStatus[] = [
  'Unscheduled',
  'Scheduled',
  'StartedAssembly',
  'FinishedAssembly',
  'StoredOnYard',
  'Shipped',
  'Delivered',
];

export function getStatusPercentages(
  productionComponentInstances: readonly ProductionComponentInstance[],
): readonly StatusPercentage[] {
  const groupedStatuses = groupBy(productionComponentInstances, (instance) => instance.status);

  const statusPercentages: StatusPercentage[] = [];
  for (const status of orderedStatuses) {
    if (status in groupedStatuses) {
      statusPercentages.push({
        status,
        percentage: Math.round((groupedStatuses[status].length / productionComponentInstances.length) * 100),
      });
    }
  }
  return statusPercentages;
}
